import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Row } from 'react-bootstrap'
import Newsletter from '../../../containers/NewsletterWidget'
import Item from './item'
import MoreButton  from '../../Buttons/plus'
import ActionBar from '../../../containers/Sections/Newsletter/actionBar'
import Spinner from '../../Spinner'
import { translate } from "react-translate"

@translate("NewsletterList")
export default class NewsletterList extends Component {

  componentWillMount(){
    window.scrollTo(0,0)
    this.props.loadNewsletters(8)
    this.props.loadCategories()
  }

   handleClick(e,total){
    e.preventDefault()
    this.props.loadNewslettersByPagination(total)
  }

  render () {

    const { newsletters, current_page, last_page, total, onFilterCategory, t, loading} = this.props;

    let baseUrl = window.location.origin;
    let newsletterUrl = baseUrl + '/newsletters';
    
        return (
          <div id="top" name="top" className="imi container-fluid">
            <ol className="route-info hidden-xs" itemScope itemType="http://schema.org/BreadcrumbList">
              <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                <a href={ baseUrl } itemProp="item" itemType="http://schema.org/Thing">
                  <span itemProp="name"><small>{t("Informacion_Novedades")}</small></span>
                  <meta itemProp="position" content="1" />
                </a>
              </li>
              
              <i className="fa fa-angle-right"></i>
              
              <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                <a href={ newsletterUrl } itemProp="item" itemType="http://schema.org/Thing">
                  <span itemProp="name"><small>{t("Newsletters")}</small></span>
                  <meta itemProp="position" content="2" />
                </a>
              </li>
            </ol>
            
            <div className="list-info-container">
              <h2 className="list-title">Newsletters</h2>
              <ActionBar categoryAction={onFilterCategory} />
							{(loading)?(<Spinner />):""}
							{(newsletters.length === 0)?(
							<div className="col-md-12 col-error">
	              <div className="no-properties-box">
	                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
	                <p>{t("No_Newsletters")}</p>
	              </div>
	            </div>
						):(
							<div>
							{(!loading)?(
								<div>
									{newsletters.map((item, index) =>
										<Col md={3} sm={6} key={index} className="col-item">
											<Item {...item} />
										</Col>
									)}
								</div>
							):""}
							</div>
						)}
            </div>
            { (current_page === last_page) ? '' : (
              <div className="btn-more-container hidden-xs">
                <MoreButton onClickMore={(e) => this.handleClick(e, total)} />
              </div> )
            }
            <div className="btn-more-container visible-xs">
              <Link className="btn btn-menu"><span className="btn-informe">{t("Ver_mas_newsletters")}</span></Link>
            </div>
            <div className="form-newsletter-container">
              <Newsletter />
            </div>
          </div>
        )


  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Newsletter/index.js